import { AbstractControl } from '@angular/forms';
// Service
import { SchemasService } from './schemas.service';
import { ValidationContext } from './validation-context';

export class VisibilityContext extends ValidationContext {

	constructor(
		control: AbstractControl,
		schemasService: SchemasService
	) {
		super(control, schemasService, true);
	}

	public IsEmpty(): any {
		return true;
	}
}
